import styled from 'styled-components';
import {dFlexColumn} from '../../../globalVariables/GlobalFlex';

export const container = styled.div`
    ${dFlexColumn};
    height: 100%;
    min-height: 0;
`;

export const cover = styled.div`
    flex: none;
    padding: var(--space-lg) var(--space-lg) 0;
`;
